export default __webpack_public_path__ + "static/media/sunset-hills.0dd5534a53e7587c9011eaeb1bde048b.svg";